export const SECONDS_IN_HOUR = 3_600 // 60 * 60
export const SECONDS_IN_8_HOURS = 28_800 // 60 * 60 * 8
export const SECONDS_IN_DAY = 86_400 // 60 * 60 * 24
export const SECONDS_IN_YEAR = 31_536_000 // 365 * 24 * 60 * 60

export const MAX_256 = 2n ** 256n - 1n

export const noValidResponses = "No valid responses"
